import React from 'react';
import { StepWrapper, StepTextWrapper } from './StepVertical.styles';
import { BodyText } from '../../../../atoms';

interface StepVerticalProps {
  stepCount: number;
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  stepText?: string;
  verticalSingleLine: boolean;
}
const StepVertical = ({
  stepCount,
  title,
  isActive,
  isCompleted,
  stepText = 'Step',
  verticalSingleLine,
}: StepVerticalProps) => {
  const stepState = isActive
    ? 'active'
    : isCompleted
    ? 'completed'
    : 'disabled';

  return (
    <StepWrapper
      size={'regular'}
      color={stepState}
      text={stepState}
      isActive={isActive}
      verticalSingleLine={verticalSingleLine}
    >
      <StepTextWrapper>
        <BodyText
          color={'inherit'}
          variant={'body3'}
          lineHeight={3}
          fontWeight={2}
        >
          {stepText.toUpperCase()} {stepCount}
        </BodyText>
      </StepTextWrapper>
      <BodyText
        color={'inherit'}
        fontWeight={2}
        variant={'body1'}
        overflow="truncate"
      >
        {title}
      </BodyText>
    </StepWrapper>
  );
};
export default StepVertical;
